import {Sprite} from 'pixi.js';
import {PieMenuItem} from './pie_menu_item/PieMenuItem';
import {CommandStrategy} from './pie_menu_commands/base/CommandStarategy';

export class PieMenuItems extends Sprite
{
    private items: PieMenuItem[] = [];

    constructor(private  innerRadius: number, private outerRadius: number, private extend: number, private itemsForWholeCircle: number = 0) {
        super();
    }

    /**
     * Отрисовка пунктов меню
     * @param zeroCorner - угол с которого начинается первый пункт меню
     * @param strategies - команды для пунктов меню
     */
    drawItems(zeroCorner: number, strategies: CommandStrategy [], tier2ItemsCount: number = -1) {
        let itemSector: number = Math.PI * 2 / (this.itemsForWholeCircle ? this.itemsForWholeCircle : strategies.length);
        let startCorner: number;
        let endCorner: number;
        let centerCorner: number;

        if (tier2ItemsCount > 0) {
            let strategy: CommandStrategy = strategies[0];
            for (let commandIndex: number = 0; commandIndex < tier2ItemsCount; commandIndex++) {
                startCorner = zeroCorner + commandIndex * itemSector;
                endCorner = startCorner + itemSector;
                centerCorner = startCorner + (endCorner - startCorner) / 2;
                this.createItem(strategy, commandIndex, startCorner, itemSector, centerCorner, true);
            }
            return;
        }

        strategies.forEach((strategy: CommandStrategy, commandIndex: number) => {
            startCorner = zeroCorner + commandIndex * itemSector;
            endCorner = startCorner + itemSector;
            centerCorner = startCorner + (endCorner - startCorner) / 2;
            this.createItem(strategy, commandIndex, startCorner, itemSector, centerCorner, false);
        });
    }

    /**
     * Очищаем пункты меню
     */
    clearItems(): void {
        let item: PieMenuItem;
        while (this.items.length) {
            item = this.items.shift()!;
            this.removeChild(item);
            item.destroy();
        }
        this.items = [];
    }

    pointerOutTier2PlayerAlone(): void {
        this.items[0].drawBack(false);
    }

    private createItem(strategy: CommandStrategy, commandIndex: number, startCorner: number, itemSector: number, centerCorner: number, isTier2: boolean): void {
        let radialMargin: number = isTier2 ? Math.PI / 200 : Math.PI / 100;
        let item: PieMenuItem = new PieMenuItem(startCorner + radialMargin, startCorner + itemSector - radialMargin, this.innerRadius, this.outerRadius, strategy, commandIndex, isTier2);
        item.x = Math.cos(centerCorner) * this.extend;
        item.y = Math.sin(centerCorner) * this.extend;
        this.addChild(item);
        this.items.push(item);
    }
}
